/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Articles Actions
export const ARTICLES_FETCH_HAS_ERRORED = 'ARTICLES_FETCH_HAS_ERRORED';
export const ARTICLES_FETCH_IS_LOADING = 'ARTICLES_FETCH_IS_LOADING';
export const ARTICLES_FETCH_SUCCESS = 'ARTICLES_FETCH_SUCCESS';

// Article Actions
export const ARTICLE_FETCH_HAS_ERRORED = 'ARTICLE_FETCH_HAS_ERRORED';
export const ARTICLE_FETCH_IS_LOADING = 'ARTICLE_FETCH_IS_LOADING';
export const ARTICLE_FETCH_SUCCESS = 'ARTICLE_FETCH_SUCCESS';

// Featured Article Actions
export const FEATURED_HAS_ERRORED = 'FEATURED_HAS_ERRORED';
export const FEATURED_IS_LOADING = 'FEATURED_IS_LOADING';
export const FEATURED_FETCH_SUCCESS = 'FEATURED_FETCH_SUCCESS';

// Homepage Featured Article Actions
export const HOMEPAGE_FEATURED_HAS_ERRORED = 'HOMEPAGE_FEATURED_HAS_ERRORED';
export const HOMEPAGE_FEATURED_IS_LOADING = 'HOMEPAGE_FEATURED_IS_LOADING';
export const HOMEPAGE_FEATURED_FETCH_SUCCESS = 'HOMEPAGE_FEATURED_FETCH_SUCCESS';

// Contact Page actions
export const FEEDBACK_SUCCESS = 'FEEDBACK_SUCCESS';
export const FEEDBACK_FAILED = 'FEEDBACK_FAILED';

// New Inventory Page actions
export const NEW_INVENTORY_SUCCESS = 'NEW_INVENTORY_SUCCESS';
export const NEW_INVENTORY_FAILED = 'NEW_INVENTORY_FAILED';
export const NEW_IMP_SUCCESS = 'NEW_IMP_SUCCESS';
export const NEW_IMP_FAILED = 'NEW_IMP_FAILED';
